import { MakeCall } from './createMakeCall';
import { PayoutInformation } from './types/ConversationPayoutInfo';
import { APIV2_URL } from './constants';

export default (makeCall: MakeCall) => (conversationId: number) =>
  makeCall<PayoutInformation>(
    'GET',
    `${APIV2_URL}/conversation/${conversationId}/payout-information`,
  );
